import router, { handleRoutes } from "../router";
import Cookies from "js-cookie";
export default {
  setToken(state, token) {
    state.token = token;
  },
  setMenus(state, menus) {
    state.menus = menus;
  },
  logout(state) {
    Cookies.remove("username");
    Cookies.remove("password");
    Cookies.remove("rememberMe");
    state.token = "";
    state.menus = [];
    state.perm.perm = [];
    state.menusStore.menusActive = "";
    state.userStore.roles = [];
    state.userStore.userMsg = { userInfo : { userName: '' }}
    router.push({
      path: "/Login",
    });
  },
  setRoutes(state) {
    handleRoutes(state.menus);
  },
  setIsKf(state, bool) {
    state.isKf = bool;
  },
};
